module.exports = __webpack_public_path__ + "img/act_box_bg.18baa9b8.png";